<main>
    <div class="content">
        <div class="image-container">
            <img [src]="baseApiUrl + '/uploads/images/management/management_1.jpg'" alt="" class="main-image">
            <p class="image-text">{{ 'management.Management' | translate }}</p>
        </div>
        <div class="paragraph">
            <h4>{{ 'management.Management Team' | translate }}</h4>
            <div class="row">
                <div class="col-lg-8 col-md-8 col-sm-8 col-12 paragraph-text sm-mb-0 mb-3">
                    <div *ngIf="currentPage == 1">
                        <div *ngFor="let person of persons1" class="container mt-4">
                            <div class="card">
                                <div class="row">
                                    <div class="col-lg-3 col-md-3 col-sm-3 col-4">
                                        <img [src]="person.img" class="card-img-top overlay-image" alt="Overlay Image">
                                    </div>
                                    <div class="col-lg-9 col-md-9 col-sm-9 col-8">
                                        <div class="card-body" *ngIf="currentLanguage === 'en'">
                                            <h5 class="card-title">{{ person.name }}</h5>
                                            <p class="card-text position">{{ person.position }}</p>
                                            <p class="card-text">{{ person.readMore ? person.fullDesc : person.shortDesc }}</p>
                                            <a (click)="readMore(person)">
                                                <span *ngIf="!person.readMore">{{ 'management.READ MORE' | translate }}</span>
                                                <span *ngIf="person.readMore">{{ 'management.READ LESS' | translate }}</span>
                                                <span><img class="icon" [src]="[ person.readMore ? person.readMoreUpIcon : person.readMoreDownIcon ]" alt=""></span>
                                            </a>
                                        </div>
                                        <div class="card-body" *ngIf="currentLanguage === 'kh'">
                                            <h5 class="card-title">{{ person.name }}</h5>
                                            <p class="card-text position">{{ person.positionKh }}</p>
                                            <p class="card-text">{{ person.readMore ? person.fullKhDesc : person.shortKhDesc }}</p>
                                            <a (click)="readMore(person)">
                                                <span *ngIf="!person.readMore">{{ 'management.READ MORE' | translate }}</span>
                                                <span *ngIf="person.readMore">{{ 'management.READ LESS' | translate }}</span>
                                                <span><img class="icon" [src]="[ person.readMore ? person.readMoreUpIcon : person.readMoreDownIcon ]" alt=""></span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="currentPage == 2">
                        <div *ngFor="let person of persons2" class="container mt-4">
                            <div class="card">
                                <div class="row">
                                    <div class="col-lg-3 col-md-3 col-sm-3 col-4">
                                        <img [src]="person.img" class="card-img-top overlay-image" alt="Overlay Image">
                                    </div>
                                    <div class="col-lg-9 col-md-9 col-sm-9 col-8">
                                        <div class="card-body" *ngIf="currentLanguage === 'en'">
                                            <h5 class="card-title">{{ person.name }}</h5>
                                            <p class="card-text position">{{ person.position }}</p>
                                            <p class="card-text">{{ person.readMore ? person.fullDesc : person.shortDesc }}</p>
                                            <a (click)="readMore(person)">
                                                <span *ngIf="!person.readMore">{{ 'management.READ MORE' | translate }}</span>
                                                <span *ngIf="person.readMore">{{ 'management.READ LESS' | translate }}</span>
                                                <span><img class="icon" [src]="[ person.readMore ? person.readMoreUpIcon : person.readMoreDownIcon ]" alt=""></span>
                                            </a>
                                        </div>
                                        <div class="card-body" *ngIf="currentLanguage === 'kh'">
                                            <h5 class="card-title">{{ person.name }}</h5>
                                            <p class="card-text position">{{ person.positionKh }}</p>
                                            <p class="card-text">{{ person.readMore ? person.fullKhDesc : person.shortKhDesc }}</p>
                                            <a (click)="readMore(person)">
                                                <span *ngIf="!person.readMore">{{ 'management.READ MORE' | translate }}</span>
                                                <span *ngIf="person.readMore">{{ 'management.READ LESS' | translate }}</span>
                                                <span><img class="icon" [src]="[ person.readMore ? person.readMoreUpIcon : person.readMoreDownIcon ]" alt=""></span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="pagination">
                        <div class="row justify-content-center">
                            <div class="col text-center">
                                <a (click)="previousPage()" [ngClass]="{disabled: isPreviousDisabled()}"><img style="width: auto; height: 35px;" [src]="page == 1 ? activePrevious : inactivePrevious" alt=""></a>
                            </div>
                            <div class="col text-center">
                                <img [src]="page == 1 ? activePaginateIcon : inactivePaginateIcon" alt="">
                            </div>
                            <div class="col text-center">
                                <img [src]="page == 2 ? activePaginateIcon : inactivePaginateIcon" alt="">
                            </div>
                            <div class="col text-center">
                                <a (click)="nextPage()" [ngClass]="{disabled: isNextDisabled()}"><img style="width: auto; height: 35px;" [src]="page == 2 ? activeNext : inactiveNext" alt=""></a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-12">
                    <app-side-menu></app-side-menu>
                </div>
            </div>
        </div>
        <div class="bottom-content-poster" style="background-color: #EDEDED; margin-top: 20px;">
            <img [src]="baseApiUrl + '/uploads/images/customer_service/customer_service_1.jpg'" alt="">
            <a href="/download-app"><img [src]="baseApiUrl + '/uploads/images/mobile_download/mobile_download_1.jpg'" loading="lazy"></a>
        </div>
    </div>
</main>